import {React,useEffect, useState} from "react";
import { useInView } from "react-intersection-observer";
import {motion} from "framer-motion";


const banner = {
  animate: {
    transition: {
        delayChildren: 1.4,
      staggerChildren: 1.1,
}
  }
};

const item = {
  staggerChildren:0.1,

  initial: { x: -50, opacity: 0 },
  animate: {
    x: 0,
    opacity: 1,
    transition: {
   
      duration: 1.0,
      ease: [0.6, 0.01, -0.05, 0.95], delay: 0.5
        
  }}
  
};

function SectionHeader(props) {
  // useEffect(() => {        document.title = title    }, [])

  const { ref:headerRef, inView: headerIsVisible } = useInView({threshold:1});


    return (<>
    <motion.div className="header__wrapper" variants={banner} initial='initial' animate='animate'>
    <span  style={{overflow:'hidden', height:'75px '
}} >
     <motion.h4 variants={item} initial='initial' animate='animate' style={{color:`${props.textColour}`, letterSpacing: '0.5rem', textShadow: '2px 1px 15px rgba(34, 35, 46, 0.5)'}}> {props.smallText}</motion.h4> </span>
      <motion.h1 variants={item} initial='initial' animate='animate'><span  style={{overflow:'hidden', height:'75px', textShadow: '2px 1px 15px rgba(34, 35, 46, 0.5)'}} >  {props.largeText}<i>{props.italics}</i>{props.largeText2}</span></motion.h1></motion.div></>
    );
    // return (<>
    //  <h4 ref={headerRef}><span  className={`${headerIsVisible?'transition-wipe':'transition-hidden'}`}>{props.smallText}</span></h4>
    //                   <h1><span className={`${headerIsVisible?'transition-wipe':'transition-hidden'}`}>{props.largeText}</span></h1></>
    // );
  }
function WorkHeader(props) {
  // useEffect(() => {        document.title = title    }, [])

  const { ref:headerRef, inView: headerIsVisible } = useInView({threshold:1});


    return (<>
    <motion.div className="header__wrapper banner" variants={banner} initial='initial' animate='animate'>
    <span  style={{overflow:'hidden', height:'75px '
}} >
     <motion.h5 variants={item} initial='initial' animate='animate' style={{paddingBottom:'1.25rem', color:`${props.textColour}`, letterSpacing: '0.5rem', textShadow: '2px 1px 15px rgba(34, 35, 46, 0.5)'}}> {props.smallText}</motion.h5> </span>
      <motion.h2 variants={item} initial='initial' animate='animate'><span  style={{overflow:'hidden', height:'75px', textShadow: '2px 1px 15px rgba(34, 35, 46, 0.5)'}} >  {props.largeText}<i>{props.italics}</i>{props.largeText2}</span></motion.h2></motion.div></>
    );
    // return (<>
    //  <h4 ref={headerRef}><span  className={`${headerIsVisible?'transition-wipe':'transition-hidden'}`}>{props.smallText}</span></h4>
    //                   <h1><span className={`${headerIsVisible?'transition-wipe':'transition-hidden'}`}>{props.largeText}</span></h1></>
    // );
  }

  export { SectionHeader, WorkHeader };
